export const TOGGLE_MODAL = 'GENERIC_TOGGLE_MODAL'

export const toggleModal = pageId => modalName => dispatch => {
  dispatch({ type: TOGGLE_MODAL, pageId, modalName })
}
